export const THEME = {
  // Poker-table palette (dark wine background, black leather rail, gold inner, blue felt)
  bgWine: 0x4a1518,
  bgWineDark: 0x2c0b0e,
  feltGreen: 0x255884,
  feltGreenDark: 0x1a4368,
  feltGreenLight: 0x3a78a8,
  rail: 0x140a0a,
  railLight: 0x2a1818,
  wood: 0xa37b3a,
  woodLight: 0xd2a55e,
  woodHighlight: 0xefc679,
  ivory: 0xfff7e0,
  cream: 0xfdf4dd,
  parchment: 0xf3e5b8,
  gold: 0xc89b2f,
  goldBright: 0xefc659,
  goldDim: 0xb08a3a,
  shadow: 0x000000,
  passDim: 0x9a9a9a,
  turnHighlight: 0xffd86b,
  cardBack: 0xa53d3d,
  cardBackEdge: 0xd17171,
  joker: 0xe6a648,
  inkDark: 0x3a2410,
} as const;

const TITLE_HUES = [
  0xc63a4a, 0xe04848, 0xee7a3e, 0xf4a83a, 0xf2cf3a, 0xc6d33a,
  0x7cba48, 0x4fa874, 0x4596a4, 0x5274b8, 0x7958c2, 0xa05cc8,
];

export function colorForRank(rank: number): number {
  if (rank >= 1 && rank <= 12) {
    return TITLE_HUES[rank - 1] ?? 0x888888;
  }
  return THEME.joker;
}

export function titleLabel(title: string): string {
  switch (title) {
    case 'great_dalmuti':
      return '대달무티';
    case 'lesser_dalmuti':
      return '부달무티';
    case 'merchant':
      return '상인';
    case 'lesser_peon':
      return '소농';
    case 'greater_peon':
      return '대농노';
    default:
      return '';
  }
}

export function titleColor(title: string): number {
  switch (title) {
    case 'great_dalmuti':
      return 0xffd86b;
    case 'lesser_dalmuti':
      return 0xe6c878;
    case 'merchant':
      return 0xb0b0b0;
    case 'lesser_peon':
      return 0xa07a4a;
    case 'greater_peon':
      return 0x8a5a3a;
    default:
      return 0xaaaaaa;
  }
}

export function phaseLabel(phase: string): string {
  switch (phase) {
    case 'waiting':
      return '대기 중 — 4명이 모이면 시작됩니다';
    case 'revolution':
      return '혁명 선언 단계';
    case 'tax':
      return '상납 단계';
    case 'playing':
      return '진행 중';
    case 'round_end':
      return '라운드 종료';
    case 'finished':
      return '매치 종료';
    default:
      return phase;
  }
}
